/**
 * Represents the geographical regions that Deckers operates in.
 *
 * Refer to the visualization below for a better understanding of each region:
 *
 * ![A graphic visualizing each region.](../.support/images/regions-explained.png "Regions Visualization").
 */
export enum Region {
  /**
   * Represents the Africa region.
   */
  AFRICA = 'AFRICA',

  /**
   * Represents the North America region. This includes the United States and
   * Canada.
   */
  NA = 'NA',

  /**
   * Represents the Europe, Middle East, and Africa region. Used by brands that
   * group these regions together. For brands that separate them, use
   * {@link EUROPE}, {@link ME}, and {@link AFRICA} instead.
   */
  EMEA = 'EMEA',

  /**
   * Represents Europe only, for brands that separate EMEA into distinct regions.
   */
  EUROPE = 'EUROPE',

  /**
   * Represents the Middle East region.
   */
  ME = 'ME',

  /**
   * Represents the Asia-Pacific region. This includes Australia, New Zealand,
   * and Japan.
   */
  APAC = 'APAC',

  /**
   * Represents the Latin America / South America region.
   */
  LATAM = 'LATAM'
}
